module.exports = __webpack_public_path__ + "img/logo.b146ef17.png";